module.exports = __webpack_public_path__ + "static/img/keco-vinyl.281d523.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/keco-vinyl.jpg
// module id = kDXx
// module chunks = 0